/**
 * Changes the input field of the form
 *
 * @param  {form} form The new text of the input field
 *
 * @return {object}    An action object with a type of CHANGE_USERNAME
 */
import {
  SAVE,
  VALUE_CHANGED,
  LOAD,
  RESET,
  RESET_GIVE_PERMISSION_STATE, SET_DEFAULT_VALUE,
} from './constants';

export function saveFormData(form) {
  return {
    type: SAVE,
    payload: form,
  };
}

export function loadFormData(form) {
  return {
    type: LOAD,
    payload: form,
  };
}

export function handleFormDataChange(propertyName, value) {
  return {
    type: VALUE_CHANGED,
    propertyName,
    value,
  };
}

export function resetFormData() {
  return {
    type: RESET,
  };
}


export function resetFormGivePermissionState() {
  return {
    type: RESET_GIVE_PERMISSION_STATE,
  };
}

export function setDefaultValue(propertyName, value) {
  return {
    type: SET_DEFAULT_VALUE,
    propertyName,
    value,
  };
}



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step17/actions.js